import { adBlockElName } from "@gik/ads/components/AdContainer";
import React from "react";

interface WordPressAdProps {
	link: string;
	imageUrl: string;
}

export default function WordPressAd({ link, imageUrl }: WordPressAdProps) {
	return (
		<a href={link} target="_blank" rel="noreferrer">
			<div
				className={adBlockElName}
				style={imageUrl ? { backgroundImage: `url("${imageUrl}")` } : {}}
			/>
		</a>
	);
}
